import styled from '@emotion/styled';

export const BarDashletAdapterWrapper = styled.div`
  position: absolute;
  top: 50px;
  bottom: 5px;
  left: 0;
  right: 0;
`;
